export class AdminRoutes{
    public static ativa: boolean = false;
    public static rotas: string[] = [];
}